import type { FaireProductEntity } from "../../entity_types/product";

export const p_z5rkfvcsun: FaireProductEntity = {
  token: "p_z5rkfvcsun",
  type: "product",
  name: "Tinned Fish Lists Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/da0eb0e01bf79fdf9676dd01e3bc0c0ffae34847227cf6a4331bc57f46ce592a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/25deab3e4c2fd6a2114c2dd782a898b44d5283b3dbb3afbf5aebe28dbd45b99f.jpeg",
    "https://cdn.faire.com/fastly/fd7943ddb08e6de504eea66c503c4b255cb90b767fee06e4342289736b8b6035.jpeg",
    "https://cdn.faire.com/fastly/3dcc2a014391e9c2dcb379fb91760ec37264c76aca8893c017b76b9884b887f9.jpeg"
  ],
  priceDollars: 4,
  description: "This playful, food-forward sticky note is perfect for jotting lists, menu ideas, and notes that deserve a little extra character.\n\nA favorite for food lovers, hosts, and stationery collectors, Tinned Fish Lists add a splash of whimsy to any workspace.\n\n𝐆𝐨𝐨𝐝 𝐭𝐨 𝐤𝐧𝐨𝐰:\n\n• 50 adhesive sheets\n• Stick & restick anywhere.\n• Measures 3in x 3in\n• 100% Recyclable",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:07.783Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
